var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-calendar-wrapper",class:_vm.viewClass},[_c('Calendar',{attrs:{"first-instance-date":_vm.firstDate,"last-instance-date":_vm.lastDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }